/** GET /api/v1/user/me relations for admin panel session bootstrap. */
export const ADMIN_ME_WITH = ["roles.permissions", "cities"]
